export enum RoleModuleAccessLevel {
	READ = "READ",
	READ_WRITE = "READ_WRITE",
	APPROVE = "APPROVE",
}

export interface RoleModule {
	id: string;
	code: string;
	name: string;
}

export interface RolePermission {
	id: string;
	moduleId: string;
	accessLevel: RoleModuleAccessLevel;
	module: RoleModule;
}

export interface RoleListItem {
	id: string;
	name: string;
	description: string | null;
	isActive: boolean;
	permissions: RolePermission[];
}
